import { createSlice, current } from '@reduxjs/toolkit';
import { isWeb } from '../../utils/Helper';
import DeviceInfo from 'react-native-device-info';

const initialState = {
    appVersion: isWeb() ? process.env.REACT_APP_VERSION_NUMBER : DeviceInfo.getVersion(), 
    appBuildNumber: isWeb() ? process.env.REACT_APP_BUILD_NUMBER : DeviceInfo.getBuildNumber(),
    appUpdateDenied: false,
    appSessionToken: null,
    appDeviceIdentifier: null,
    clientId: null,
    ConnectorIP: null,
    tempSelectedHotel: {},
    redirectToTabId: null,
    fcmToken: "",
    isAutoLoggedIn: false,
    serviceStatus: {
        hasError: false,
        errorMessage: ""
    },
    goHome: false,
    canProceedRenderApp: false,
    renderApp: false,
    isOnline: true,
    showOfflineMessage: false,
    initAppLogout: false,
    overlayVisible: false,
    renderLoader: {
        isVisible: false,
        loaderMessage: ""
    },
    renderFlashMessage: {
        isVisible: false,
        messageConfig: {}
    },
    renderIpChangeModal: false,
    renderInfoPopup: {
        isVisible: false,
        popupConfig: {}
    },
    showLoginModal: false,
    proceedHotelSelection: {
        init: false,
        hotel_Code: null
    },
    proceedLoginToTheApp: {
        init: false,
        guestDetails: {
            lastName: "",
            roomNumber: "",
            candoAccompanyLogin: true,
            candoOtpFlow: true
        }
    },
    isLoggedIn: false,
    loggedInRoomNumber: null,
    shownWelcomeScreen: false,
    openChat: false,
    layoutCssData: null,
    doorKeyType: ""
};
 
const appConfigSlice = createSlice({
    name: 'appConfig',
    initialState,
    reducers: {
        resetAppConfig: (state) => ({
            ...initialState,
            clientId: state.clientId,
            ConnectorIP: state.ConnectorIP,
            shownWelcomeScreen: state.shownWelcomeScreen,
            fcmToken: state.fcmToken,
            isAutoLoggedIn: state.isAutoLoggedIn,
            appUpdateDenied: state.appUpdateDenied,
        }),
        setRedirectToTabId: (state, action)=>{
            state.redirectToTabId = action.payload;
        },
        setSessionToken: (state, action) => {
            state.appSessionToken = action.payload;
        },
        setDeviceIdentifier: (state, action) => {
            state.appDeviceIdentifier = action.payload;
        },
        setConnectorIP: (state, action) => {
            state.ConnectorIP = action.payload
        },
        setClientId: (state, action) => {
            state.clientId = action.payload
        },
        setTempSelectedHotel: (state, action) => {
            state.tempSelectedHotel = action.payload || {};
        },
        setAppUpdateDenied: (state, action) => {
            state.appUpdateDenied = action.payload
        },
        setFCMToken: (state, action) => {
            state.fcmToken = action.payload
        },
        setIsAutoLoggedIn: (state, action) => {
            state.isAutoLoggedIn = action.payload;
        },
        setServiceStatus: (state, action) => {
            state.serviceStatus = {
                hasError: action.payload.hasError,
                errorMessage: action.payload.errorMessage
            }
        },
        setGoHome: (state, action) => {
            state.goHome = action.payload
        },
        setCanProceedRenderApp: (state, action) => {
            state.canProceedRenderApp = action.payload;
        },
        setRenderApp: (state, action) => {
            state.renderApp = action.payload
        },
        setInitAppLogout: (state, action) => {
            state.initAppLogout = action.payload;
        },
        setOverlayVisible: (state, action) => {
            state.overlayVisible = action.payload;
        },
        setProceedHotelSelection: (state, action) => {
            const { init, hotel_Code } = action.payload;

            state.proceedHotelSelection = {
                init,
                hotel_Code: init ? hotel_Code : null
            }
        },
        tweekProceedLoginToTheApp: (state, action) => {
            const { init, guestDetails = {} } = action.payload;
        
            state.proceedLoginToTheApp = {
                init: init && Object.keys(guestDetails).length > 0 ? true : false,
                guestDetails: guestDetails,
            };
        },
        tweekAppLoader: (state, action) => {
            const { isVisible, loaderMessage = '' } = action.payload;
        
            state.renderLoader = {
                isVisible,
                loaderMessage: isVisible ? loaderMessage : '',
            };
        },
        tweekFlashMessage: (state, action) => {
            const { isVisible, messageConfig={} } = action.payload;

            state.renderFlashMessage = {
                isVisible,
                messageConfig: isVisible ? messageConfig : {}
            };
        },
        tweekInfoPopup: (state, action) => {
            state.renderInfoPopup = {
                isVisible: action.payload.isVisible,
                popupConfig: action.payload.isVisible ? action.payload.popupConfig : {}
            }
        },
        setShowLoginModal: (state, action) => {
            state.showLoginModal = action.payload;
        },
        setIsLoggedIn: (state, action) => {
            state.isLoggedIn = action.payload
        },
        setLoggedInRoomNumber: (state, action) => {
            state.loggedInRoomNumber = action.payload
        },
        setIsShownWelcomeScreen: (state, action) => {
            state.shownWelcomeScreen = action.payload
        },
        setOpenChat: (state, action) => {
            state.openChat = action.payload
        },
        setLayoutCssData: (state, action)=>{
            state.layoutCssData = action.payload
        },
        setDoorKeyType: (state, action) => {
            state.doorKeyType = action.payload
        },
        setRenderIpChangeModal: (state, action)=>{
            state.renderIpChangeModal = action.payload;
        },
        setIsOnline: (state, action) => {
            state.isOnline = action.payload;
            // state.showOfflineMessage = !action.payload;
        },
        setShowOfflineMessage: (state, action) => {
            state.showOfflineMessage = action.payload;
        }
    },
});


export const { resetAppConfig, setSessionToken, setDeviceIdentifier, setConnectorIP, setClientId, setTempSelectedHotel, setRedirectToTabId, setAppUpdateDenied, setFCMToken, setIsAutoLoggedIn, setServiceStatus, setGoHome, setCanProceedRenderApp, setRenderApp, setInitAppLogout, setOverlayVisible, setProceedHotelSelection, tweekProceedLoginToTheApp, tweekAppLoader, tweekFlashMessage, tweekInfoPopup, setShowLoginModal, setIsLoggedIn, setLoggedInRoomNumber, setIsShownWelcomeScreen, setOpenChat, setLayoutCssData, setDoorKeyType, setRenderIpChangeModal, setIsOnline, setShowOfflineMessage  } = appConfigSlice.actions;

export default appConfigSlice.reducer;
